<template>
    <layout-general-container :noSideSpacer="false" spaceToolbar v-if="event">
        <div class="container xl:px-36 lg:px-12 md:px-8 px-4">
            <div class="w-full max-h-[30rem] overflow-hidden mt-12 rounded-md">
                <img :src="event?.featured_image" alt="image src" class="w-full h-full">
            </div>
            <h1 class="xl:text-4xl lg:text-2xl text-base font-semibold mt-5">
                {{ event?.title }}
            </h1>
            <article class="mt-8 text-justify" v-html="sanitizedDesc(event?.content)">
            </article>
        </div>

        <div class="flex gap-4 mx-auto mt-12">
            <a-button v-for="(tag, tagIndex) in event.tags" :key="tagIndex" class="flex gap-1 h-auto rounded-full align-middle justify-items-center text-gray-500 py-2 px-4" @click="$router.push('/Graduates/?tag='+tag)">
                <template #icon>
                    <IconBookmark class="text-gray-500" />
                </template>
                {{tag}}
            </a-button>
        </div>
    </layout-general-container>
</template>

<script setup="ts">
import imgSrc from "@/assets/img/graduates/nadea-nabilla.jpeg";
import { IconBookmark } from "@tabler/icons-vue";
import DOMPurify from 'dompurify';
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import NotFound from "../NotFound.vue";
import axiosInstance from "../../plugins/axios";

const route = useRoute();
const router = useRouter();
const event = ref(null);

const sanitizedDesc = (desc) => {
    return DOMPurify.sanitize(desc, {
        ADD_TAGS: ['iframe', 'div'],
        ADD_ATTR: ['src', 'allow', 'allowfullscreen', 'frameborder', 'data-oembed-url'],
    });
}

const fetchEventDetail = async () => {
    try {
        const response = await axiosInstance.get(`/articles/${route.params.EventID}`);
        event.value = response?.data;
    } catch (error) {
        if (error.response && error.response.status === 404) {
            router.replace({ name: 'NotFound' });
        }

        console.error('Error fetching event detail:', error)
    }
};

onMounted(() => {
    fetchEventDetail();
});
</script>